module.exports = __webpack_public_path__ + "img/active_employee.57f7e56d.svg";